import React, { useState } from "react";
import { IonAlert } from "@ionic/react";
import "./PasswordModal.css";

interface PasswordModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: (password: string) => void;
  onCancel: () => void;
}

const PasswordModal: React.FC<PasswordModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  const handleCancel = () => {
    onCancel();
  };

  return (
    <IonAlert
      isOpen={isOpen}
      header={title}
      message={message}
      inputs={[
        {
          name: "password",
          type: "password",
          placeholder: "Enter your password",
        },
      ]}
      buttons={[
        {
          text: "Cancel",
          role: "cancel",
          handler: handleCancel,
          cssClass: "cancel-button",
        },
        {
          text: "Proceed",
          handler: (data) => {
            if (data.password && data.password.trim()) {
              onConfirm(data.password);
              return true;
            }
            return false;
          },
        },
      ]}
      onDidDismiss={handleCancel}
    />
  );
};

export default PasswordModal;
